import React from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'

export let startUserRoles = (userId) => {
  const root = createRoot(document.getElementById('userRolesApp'))
  root.render(<App userId={userId} />)
}
